import { PREFIX } from './base';

export const CORRELATION_X = `${PREFIX}_CORRELATION_X`;
export const CORRELATION_Y = `${PREFIX}_CORRELATION_Y`;
export const CORRELATION_SIZE = `${PREFIX}_CORRELATION_SIZE`;
